var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.468,74.312c6.334,0,11.469-5.136,11.469-11.47s-5.135-11.469-11.469-11.469S0,56.51,0,62.844 S5.134,74.312,11.468,74.312"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.468,100c6.334,0,11.469-5.134,11.469-11.468c0-6.335-5.135-11.47-11.469-11.47S0,82.197,0,88.532 C0,94.866,5.134,100,11.468,100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.156,74.312c6.334,0,11.468-5.136,11.468-11.47S43.49,51.375,37.156,51.375 c-6.334,0-11.468,5.135-11.468,11.469S30.822,74.312,37.156,74.312"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.156,100c6.334,0,11.468-5.134,11.468-11.468c0-6.335-5.134-11.47-11.468-11.47 c-6.334,0-11.469,5.135-11.469,11.47C25.688,94.866,30.822,100,37.156,100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50,22.937c6.334,0,11.469-5.135,11.469-11.469S56.334,0,50,0S38.532,5.134,38.532,11.468 S43.666,22.937,50,22.937"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.846,74.312c6.331,0,11.467-5.136,11.467-11.47s-5.136-11.469-11.467-11.469 c-6.336,0-11.471,5.135-11.471,11.469S56.51,74.312,62.846,74.312"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.846,100c6.331,0,11.467-5.134,11.467-11.468c0-6.335-5.136-11.47-11.467-11.47 c-6.336,0-11.471,5.135-11.471,11.47C51.375,94.866,56.51,100,62.846,100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.532,74.312c6.334,0,11.468-5.136,11.468-11.47s-5.134-11.469-11.468-11.469 c-6.335,0-11.47,5.135-11.47,11.469S82.197,74.312,88.532,74.312"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.532,100C94.866,100,100,94.866,100,88.532c0-6.335-5.134-11.47-11.468-11.47 c-6.335,0-11.47,5.135-11.47,11.47C77.062,94.866,82.197,100,88.532,100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependent);
export default __webpack_public_path__ + "static/media/independent.cf5bb5d12d49bbb42d66a5a68e6cfe52.svg";
export { ForwardRef as ReactComponent };